const regexPatterns = [
  /^[A-Za-z]{3}\d{1,3}[A-Za-z]?$/, // Pattern 1: 3 letters, 3 numbers, optional ending letter
  /^\d{3}[A-Za-z]{2}\d{1,3}[A-Za-z]{1,2}$/, // Pattern 2: 3 numbers, 2 letters, numbers, optional letter
  /^\d{2}[A-Za-z]{2}\d{1,3}[A-Za-z]{1,2}$/, // Pattern 3: 2 numbers, 2 letters, numbers, optional letter
  /^[A-Za-z]{2}\d{2}[A-Za-z]?\d{1,3}$/, // Pattern 4: 2 letters, numbers, optional letter, optional numbers
  /^[A-Za-z]{4}\d{3}[A-Za-z]{1,2}$/, // Pattern 5: 4 letters, numbers, optional ending letters
  /^[A-Za-z]{3}\d[A-Za-z]\d{2}$/, // Pattern 6: 3 letters, 1 number, 1 letter, 2 numbers
  /^\d{2}[A-Za-z]{4}\d{2}[A-Za-z]$/, // Pattern 7: 2 numbers, 4 letters, numbers, 1 letter
  /^[A-Za-z]{3}\d{2}[A-Za-z]$/, // Pattern 8: 3 letters, 2 numbers, 1 letter
  /^\d{2}[A-Za-z]{3}\d{2}[A-Za-z]$/, // Pattern 9: 2 numbers, 3 letters, numbers, 1 letter
];

export default {
  clearForm(data) {
    Object.keys(data).forEach((key, index) => { // eslint-disable-line no-unused-vars
      // eslint-disable-next-line no-param-reassign
      data[key] = '';
    });
  },
  numberToString(num) {
    return Number(num).toLocaleString('en');
  },
  stringToNumber(num) {
    return parseInt(num.replace(/\D/g, ''), 10);
  },
  objIsEmpty(obj) {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  },
  isPWA() {
    return window?.matchMedia?.('(display-mode: standalone)')?.matches;
  },
  getNumberPlateRegex() {
    // Combine all regex patterns into a single regex using the | operator
    const combinedPattern = regexPatterns.map((pattern) => pattern.source).join('|');
    return new RegExp(`(${combinedPattern})`);
  },
};
